import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { EnterpriseStore } from './enterprise.store';
import { customerBaseUrl } from './runtime-env';

// enterpriseInterceptor 给发往 customer BFF 的请求注入 X-Enterprise-Id（当前选中企业 application_id）。
// BFF 据此把账户/交易/仪表盘等按选中企业隔离（见 customer resolveCustomerID）。
// 仅在有选中企业且目标是 BFF 域时注入；读 signal 不触发加载，无副作用。
export const enterpriseInterceptor: HttpInterceptorFn = (req, next) => {
  const ent = inject(EnterpriseStore);
  const id = ent.activeId();
  if (id && req.url.startsWith(customerBaseUrl())) {
    return next(req.clone({ setHeaders: { 'X-Enterprise-Id': id } }));
  }
  return next(req);
};
